import create from "zustand"

export const useStore = create((set) => ({
    me: {
        isNice: false,
        isNaughty: false
    },
    questionMode: false,
    questions: null,
    question: 0,
    rotation: 0,
    score: 0,
    updateMe: (me) => set((state) => ({ me: { ...state.me, ...me}})),
    updateQuestionMode: (questionMode) => set((state) => ({ questionMode: { ...state.questionMode, ...questionMode } })),
    // setScore: (score) => set((state) => ({ score: { ...state.score, ...score }})),
    // setScore: (rotation) => set((state) => ({ score: { ...state.score, ...rotation}})),
    setScore: (rotation) => set((state) => ({ score: { ...state.score, rotation }})),
    increaseRotation: () => set(state => ({ rotation: state.rotation + 45})),
    decreaseRotation: () => set(state => ({ rotation: state.rotation - 45})),
    increaseQuestion: () => set(state => ({ question: state.question + 1})),
    clearRotation: () => set({ rotation: 0 })
    // increaseRotation: (rotation) => set((state) => ({ rotation: { ...state.rotation, ...rotation}})),
}))